import Rsvps from '../../../../../store/rsvps';
import templateUrl from './contact-rsvps.tpl.html';

class ContactRsvpsCtrl {

    constructor(Rsvps, $state, $stateParams, addContactToGuestlist) {
        this.rsvps = Rsvps;
        this.state = $state;
        this.params = _.cloneDeep($stateParams);
        this.params.tab = 'rsvps';
        this.addAction = addContactToGuestlist;
    }

    $onInit() {
        this.loadRsvps();
    }


    loadRsvps() {
        const $state = this.state;
        const params = this.params;
        this.store = this.rsvps.create('RsvpsListview' + this.contact.id);

        // this.store.commit('disableExtendedListView');
        this.store.commit('setPermanentFilters', {'contact.id': this.contact.id});
        // this.store.commit('setVisible', ['guestlist.name', 'guestlist.date', 'pax_planned', 'pax_actual', 'status']);
        this.store.commit('setVisible', [
            'contact.id',
            'guestlist.id',
            'guestlist.name',
            'guestlist_combination.name',
            'seatplan_area.title',
            'area_start_time',
            'area_end_time',
            'guestlist.date',
            'status',
            'pax_planned',
            'seatplan_element_pax',
            'seatplan_elements'
        ]);
        this.store.commit('setSort', {
            'guestlist.date': 'desc'
        });
        this.store.commit('setIncludeDeletedGuestlists', true);

        this.store.commit('addAction', {
            key: 'details',
            text: 'Details',
            level: 'row',
            class: 'btn green',
            action({row}) {
                $state.go('app.guestlists.rsvps.details.overview', {
                    gid: row.guestlist.id,
                    id: row.id,
                    back: $state.current.name,
                    backParams: params
                })
            }
        });
        this.store.commit('addAction', this.addAction);

        this.store.commit('addAction', {
            key: 'show_archived',
            title: 'Show archived',
            level: 'settings',
            manager: 'showArchived'
        });

        this.store.commit('setVm', this);
    }

}


ContactRsvpsCtrl.$inject = ['Rsvps', '$state', '$stateParams', 'addContactToGuestlist'];


angular
    .module('festzelt-os.contacts')
    .component('contactRsvps', {
        bindings: {
            contact: '='
        },
        controller: ContactRsvpsCtrl,
        controllerAs: 'vm',
        templateUrl: templateUrl
    });



// WEBPACK FOOTER //
// ./src/app/pages/contacts/directives/sections/rsvps/contact-rsvps.js